import type { TMessages } from '@/types/TMessages'

export const messages = {
  moreLots: 'Посмотреть все предложения',
} satisfies TMessages
